export let environmentReady: Promise<void>;
let resolveReady!: () => void;

environmentReady = new Promise<void>(res => {
  resolveReady = res;
});

export function markEnvironmentReady() {
  resolveReady();
}
